module.exports = __webpack_public_path__ + "static/media/BJ.dea90e43.svg";